<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Login v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <img :src="require('@/assets/images/banner.png')" alt="" style="width: 80%">
        </b-link>

        <b-card-title class="mb-1">
          مرحباً بك 👋
        </b-card-title>
        <b-card-text class="mb-2">
          قم بتسجيل الدخول للمتابعة
        </b-card-text>

        <div class="alert alert-success text-center g" id="error" v-if="ss">
          {{ ss }}
        </div>

        <!-- form -->
        <validation-observer
          ref="loginForm"
          #default="{invalid}"
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="dox()"
          >

            <template v-if="requireOTP">
              <!-- OTP -->
              <b-form-group
                label-for="OTP"
                label="OTP"
              >
                <validation-provider
                  #default="{ errors }"
                  name="OTP"
                  rules="required"
                >
                  <b-form-input
                    id="email" class="form-control-lg"
                    v-model="otp"
                    name="login-email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="OTP here..."
                    autofocus
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </template>
            <template v-if="!requireOTP">
              <!-- email -->
              <b-form-group
                label-for="email"
                label="رقم الجوال"
              >
                <validation-provider
                  #default="{ errors }"
                  name="رقم الجوال"
                  rules="required"
                >
                  <b-form-input
                    id="email" class="form-control-lg"
                    v-model="userEmail"
                    name="login-email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="رقم الجوال هنا..."
                    autofocus
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="password">كلمة المرور</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="كلمة المرور"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="password" 
                      v-model="password"
                      :type="passwordFieldType"
                      class="form-control-merge form-control-lg"
                      :state="errors.length > 0 ? false:null"
                      name="login-password"
                      placeholder="كلمة المرور هنا..."
                    />

                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </template>

            <div class="alert alert-danger text-center g" id="error" v-if="error">
              {{ error }}
            </div>

            <!-- submit button -->
            <b-button
              variant="primary"
              type="submit"
              block
              :disabled="invalid"
            >
              تسجيل الدخول
            </b-button>
          </b-form>
          <div class="col-12 text-center g"><br>
            <a href="/register" class="text-info">
              <i class="fa fa-user-plus"></i>
              إنشاء حساب جديد
            </a>
          </div>
        </validation-observer>

      </b-card>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton, BForm, BFormInput, BFormGroup, BCard, BLink, BCardTitle, BCardText, BInputGroup, BInputGroupAppend, BFormCheckbox,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  created(){
    var g = this;
    if(window.location.href.includes("username=")){
      g.dox()
    }
  },
  methods: {
    dox(){
      var g = this;
      g.error = null;
      if(!g.requireOTP){
        $.post(api + '/user/auth/login', {
          phone: g.userEmail,
          country: g.country,
          password: g.password
        })
        .then(function(r){
          if(r.status != 100){
            g.error = r.response
          }else{
            g.requireOTP = true;
            g.otp_id = r.response;
          }
        })
        .fail(function(){
          g.error = "حدث خطأ عند الاتصال بالخادم"
        })
      }else{
        $.post(api + '/user/auth/otp', {
           id: g.otp_id,
           otp: g.otp
          })
          .then(function(r){
            if(r.status != 100){
              g.error = r.response
            }else{
              localStorage.setItem("user", JSON.stringify(r.response))
              window.location = '/'
            }
          })
          .fail(function(){
            g.error = "حدث خطأ عند الاتصال بالخادم"
          })
      }
    }
  },
  data() {
    return {
      userEmail: window.location.href.includes("username=") ? window.location.href.split("username=")[1].split("&")[0] : "",
      password: window.location.href.includes("password=") ? window.location.href.split("password=")[1].split("&")[0] : "",
      error: null,
      status: '',
      requireOTP: false,
      ss: window.location?.hash?.includes("ss") ? 'تم إنشاء الحساب بنجاح، قم بتسجيل الدخول الآن' : false,
      otp: "",
      otp_id: "",
      pass: window.location.href.includes("?pass"),
      // validation rules
      required,
      email,
      country: window.location.href.includes("country=") ? window.location.href.split("country=")[1].split("&")[0] : "Egypt",
      countries: [
          {
            "ar": "مصر",
            "en": "Egypt",
            "code": "EG"
          },
          {
            "ar": "العربية السعودية",
            "en": "Saudi Arabia",
            "code": "SA"
          },
          {
            "ar": "الجزائر",
            "en": "Algeria",
            "code": "DZ"
          },
          {
            "ar": "دولة الإمارات العربية المتحدة",
            "en": "United Arab Emirates",
            "code": "AE"
          },
          {
            "ar": "عمان",
            "en": "Oman",
            "code": "OM"
          },
          {
            "ar": "فلسطين",
            "en": "Palestine",
            "code": "PS"
          },
          {
            "ar": "البحرين",
            "en": "Bahrain",
            "code": "BH"
          },
          {
            "ar": "قطر",
            "en": "Qatar",
            "code": "QA"
          },
          {
            "ar": "الكويت",
            "en": "Kuwait",
            "code": "KW"
          },
          {
            "ar": "لبنان",
            "en": "Lebanon",
            "code": "LB"
          },
          {
            "ar": "ليبيا",
            "en": "Libya",
            "code": "LY"
          },
          {
            "ar": "موريتانيا",
            "en": "Mauritania",
            "code": "MR"
          },
          {
            "ar": "المغرب",
            "en": "Morocco",
            "code": "MA"
          },
          {
            "ar": "السودان",
            "en": "Sudan",
            "code": "SD"
          },
          {
            "ar": "تونس",
            "en": "Tunisia",
            "code": "TN"
          },
          {
            "ar": "سوريا",
            "en": "Syria",
            "code": "SY"
          },
          {
            "ar": "اليمن",
            "en": "Yemen",
            "code": "YE"
          },
          {
            "ar": "العراق",
            "en": "Iraq",
            "code": "IQ"
          },
          {
            "ar": "الاردن",
            "en": "Jordan",
            "code": "JO"
          },
          {
            "ar": "جيبوتى",
            "en": "Djibouti",
            "code": "DJ"
          },
          {
            "ar": "الصومال",
            "en": "Somalia",
            "code": "SO"
          },
          {
            "ar": "القمر",
            "en": "Comoros",
            "code": "KM"
          },
          {
            "ar": "أفغانستان",
            "en": "Afghanistan",
            "code": "AF"
          },
          {
            "ar": "باكستان",
            "en": "Pakistan",
            "code": "PK"
          },
          {
            "ar": "بهوتان",
            "en": "Bhutan",
            "code": "BT"
          },
          {
            "ar": "جمهورية كوريا الديمقراطية الشعبية",
            "en": "North Korea",
            "code": "KP"
          },
          {
            "ar": "تيمور الشرقية",
            "en": "Timor-Leste",
            "code": "TL"
          },
          {
            "ar": "فلبين",
            "en": "Philippines",
            "code": "PH"
          },
          {
            "ar": "جمهورية كوريا",
            "en": "South Korea",
            "code": "KR"
          },
          {
            "ar": "كمبوديا",
            "en": "Cambodia",
            "code": "KH"
          },
          {
            "ar": "لاوس",
            "en": "Laos",
            "code": "LA"
          },
          {
            "ar": "مالديف",
            "en": "Maldives",
            "code": "MV"
          },
          {
            "ar": "ماليزيا",
            "en": "Malaysia",
            "code": "MY"
          },
          {
            "ar": "منغوليا",
            "en": "Mongolia",
            "code": "MN"
          },
          {
            "ar": "بنجلاديش",
            "en": "Bangladesh",
            "code": "BD"
          },
          {
            "ar": "ميانمار",
            "en": "Myanmar",
            "code": "MM"
          },
          {
            "ar": "النيبال",
            "en": "Nepal",
            "code": "NP"
          },
          {
            "ar": "اليابان",
            "en": "Japan",
            "code": "JP"
          },
          {
            "ar": "سرى لانكا",
            "en": "Sri Lanka",
            "code": "LK"
          },
          {
            "ar": "تايلاند",
            "en": "Thailand",
            "code": "TH"
          },
          {
            "ar": "برونى",
            "en": "Brunei",
            "code": "BN"
          },
          {
            "ar": "سنفافورا",
            "en": "Singapore",
            "code": "SG"
          },
          {
            "ar": "الهند",
            "en": "India",
            "code": "IN"
          },
          {
            "ar": "اندونيسيا",
            "en": "Indonesia",
            "code": "ID"
          },
          {
            "ar": "فيتنام",
            "en": "Vietnam",
            "code": "VN"
          },
          {
            "ar": "تركيا",
            "en": "Turkey",
            "code": "TR"
          },
          {
            "ar": "ايران",
            "en": "Iran",
            "code": "IR"
          },
          {
            "ar": "اسرائيل",
            "en": "Israel",
            "code": "IL"
          },
          {
            "ar": "اثيوبيا",
            "en": "Ethiopia",
            "code": "ET"
          },
          {
            "ar": "انغولا",
            "en": "Angola",
            "code": "AO"
          },
          {
            "ar": "بينين",
            "en": "Benin",
            "code": "BJ"
          },
          {
            "ar": "بوتسوانا",
            "en": "Botswana",
            "code": "BW"
          },
          {
            "ar": "بوروندى",
            "en": "Burundi",
            "code": "BI"
          },
          {
            "ar": "غينيا الاستوائية",
            "en": "Equatorial Guinea",
            "code": "GQ"
          },
          {
            "ar": "توجو",
            "en": "Togo",
            "code": "TG"
          },
          {
            "ar": "ارتريا",
            "en": "Eritrea",
            "code": "ER"
          },
          {
            "ar": "الرأس الاخضر",
            "en": "Cape Verde",
            "code": "CV"
          },
          {
            "ar": "غمبيا",
            "en": "Gambia",
            "code": "GM"
          },
          {
            "ar": "جمهورية الكونغو",
            "en": "Republic of the Congo",
            "code": "CG"
          },
          {
            "ar": "جمهورية الكونغو الديمقراطية",
            "en": "Democratic Republic of the Congo",
            "code": "CD"
          },
          {
            "ar": "غينيا",
            "en": "Guinea",
            "code": "GN"
          },
          {
            "ar": "بيساو - غينيا",
            "en": "Guinea-Bissau",
            "code": "GW"
          },
          {
            "ar": "غانا",
            "en": "Ghana",
            "code": "GH"
          },
          {
            "ar": "الغابون",
            "en": "Gabon",
            "code": "GA"
          },
          {
            "ar": "زيمبابوى",
            "en": "Zimbabwe",
            "code": "ZW"
          },
          {
            "ar": "الكمرون",
            "en": "Cameroon",
            "code": "CM"
          },
          {
            "ar": "كوت دى فوار",
            "en": "Côte d'Ivoire",
            "code": "CI"
          },
          {
            "ar": "كينيا",
            "en": "Kenya",
            "code": "KE"
          },
          {
            "ar": "ليسوتو",
            "en": "Lesotho",
            "code": "LS"
          },
          {
            "ar": "ليبريا",
            "en": "Liberia",
            "code": "LR"
          },
          {
            "ar": "رواندا",
            "en": "Rwanda",
            "code": "RW"
          },
          {
            "ar": "مدغشقر",
            "en": "Madagascar",
            "code": "MG"
          },
          {
            "ar": "مالى",
            "en": "Mali",
            "code": "ML"
          },
          {
            "ar": "موريشيوس",
            "en": "Mauritius",
            "code": "MU"
          },
          {
            "ar": "موزمبيق",
            "en": "Mozambique",
            "code": "MZ"
          },
          {
            "ar": "ناميبيا",
            "en": "Namibia",
            "code": "NA"
          },
          {
            "ar": "جنوب أفريقيا",
            "en": "South Africa",
            "code": "ZA"
          },
          {
            "ar": "النيجر",
            "en": "Niger",
            "code": "NE"
          },
          {
            "ar": "نيجيريا",
            "en": "Nigeria",
            "code": "NG"
          },
          {
            "ar": "سيراليون",
            "en": "Sierra Leone",
            "code": "SL"
          },
          {
            "ar": "السنغال",
            "en": "Senegal",
            "code": "SN"
          },
          {
            "ar": "سيشيل",
            "en": "Seychelles",
            "code": "SC"
          },
          {
            "ar": "تانزانيا",
            "en": "Tanzania",
            "code": "TZ"
          },
          {
            "ar": "اوغندا",
            "en": "Uganda",
            "code": "UG"
          },
          {
            "ar": "زامبيا",
            "en": "Zambia",
            "code": "ZM"
          },
          {
            "ar": "تشاد",
            "en": "Chad",
            "code": "TD"
          },
          {
            "ar": "جمهورية أفريقيا الوسطى",
            "en": "Central African Republic",
            "code": "CF"
          },
          {
            "ar": "اذربيجان",
            "en": "Azerbaijan",
            "code": "AZ"
          },
          {
            "ar": "روسيا البيضاء",
            "en": "Belarus",
            "code": "BY"
          },
          {
            "ar": "روسيا",
            "en": "Russia",
            "code": "RU"
          },
          {
            "ar": "جيورجيا",
            "en": "Georgia",
            "code": "GE"
          },
          {
            "ar": "قازقستان",
            "en": "Kazakhstan",
            "code": "KZ"
          },
          {
            "ar": "قرغيزستان",
            "en": "Kyrgyzstan",
            "code": "KG"
          },
          {
            "ar": "مولدوفا",
            "en": "Moldova",
            "code": "MD"
          },
          {
            "ar": "طاجيكستان",
            "en": "Tajikistan",
            "code": "TJ"
          },
          {
            "ar": "تركمانستان",
            "en": "Turkmenistan",
            "code": "TM"
          },
          {
            "ar": "اوكرانيا",
            "en": "Ukraine",
            "code": "UA"
          },
          {
            "ar": "أوزبكستان",
            "en": "Uzbekistan",
            "code": "UZ"
          },
          {
            "ar": "ارمينيا",
            "en": "Armenia",
            "code": "AM"
          },
          {
            "ar": "قبرص",
            "en": "Cyprus",
            "code": "CY"
          },
          {
            "ar": "ألبانيا",
            "en": "Albania",
            "code": "AL"
          },
          {
            "ar": "أستونيا",
            "en": "Estonia",
            "code": "EE"
          },
          {
            "ar": "بلغاريا",
            "en": "Bulgaria",
            "code": "BG"
          },
          {
            "ar": "بولندا",
            "en": "Poland",
            "code": "PL"
          },
          {
            "ar": "البوسنة والهرسك",
            "en": "Bosnia and Herzegovina",
            "code": "BA"
          },
          {
            "ar": "تشيك",
            "en": "Czech Republic",
            "code": "CZ"
          },
          {
            "ar": "كرواتيا",
            "en": "Croatia",
            "code": "HR"
          },
          {
            "ar": "لاتفيا",
            "en": "Latvia",
            "code": "LV"
          },
          {
            "ar": "ليتوانيا",
            "en": "Lithuania",
            "code": "LT"
          },
          {
            "ar": "رومانيا",
            "en": "Romania",
            "code": "RO"
          },
          {
            "ar": "مقدونيا",
            "en": "North Macedonia",
            "code": "MK"
          },
          {
            "ar": "الصرب والجبل الأسود",
            "en": "Serbia and Montenegro",
            "code": "CS"
          },
          {
            "ar": "سلوفاكيا",
            "en": "Slovakia",
            "code": "SK"
          },
          {
            "ar": "سلوفينيا",
            "en": "Slovenia",
            "code": "SI"
          },
          {
            "ar": "المجر",
            "en": "Hungary",
            "code": "HU"
          },
          {
            "ar": "ايراندا",
            "en": "Ireland",
            "code": "IE"
          },
          {
            "ar": "اندورا",
            "en": "Andorra",
            "code": "AD"
          },
          {
            "ar": "النمسا",
            "en": "Austria",
            "code": "AT"
          },
          {
            "ar": "بلجيكا",
            "en": "Belgium",
            "code": "BE"
          },
          {
            "ar": "ايسلندا",
            "en": "Iceland",
            "code": "IS"
          },
          {
            "ar": "الدنمارك",
            "en": "Denmark",
            "code": "DK"
          },
          {
            "ar": "ألمانيا",
            "en": "Germany",
            "code": "DE"
          },
          {
            "ar": "فرنسا",
            "en": "France",
            "code": "FR"
          },
          {
            "ar": "فنلندا",
            "en": "Finland",
            "code": "FI"
          },
          {
            "ar": "هولندا",
            "en": "Netherlands",
            "code": "NL"
          },
          {
            "ar": "لوكسمبورغ",
            "en": "Luxembourg",
            "code": "LU"
          },
          {
            "ar": "ليجتنشتين",
            "en": "Liechtenstein",
            "code": "LI"
          },
          {
            "ar": "مالطه",
            "en": "Malta",
            "code": "MT"
          },
          {
            "ar": "موناكو",
            "en": "Monaco",
            "code": "MC"
          },
          {
            "ar": "النرويج",
            "en": "Norway",
            "code": "NO"
          },
          {
            "ar": "البرتغال",
            "en": "Portugal",
            "code": "PT"
          },
          {
            "ar": "السويد",
            "en": "Sweden",
            "code": "SE"
          },
          {
            "ar": "سويسرا",
            "en": "Switzerland",
            "code": "CH"
          },
          {
            "ar": "اسبانيا",
            "en": "Spain",
            "code": "ES"
          },
          {
            "ar": "اليونان",
            "en": "Greece",
            "code": "GR"
          },
          {
            "ar": "ايطاليا",
            "en": "Italy",
            "code": "IT"
          },
          {
            "ar": "بريطانيا",
            "en": "United Kingdom",
            "code": "GB"
          },
          {
            "ar": "استراليا",
            "en": "Australia",
            "code": "AU"
          },
          {
            "ar": "بابوا نيو غينيا",
            "en": "Papua New Guinea",
            "code": "PG"
          },
          {
            "ar": "فيجي",
            "en": "Fiji",
            "code": "FJ"
          },
          {
            "ar": "كيريباتي",
            "en": "Kiribati",
            "code": "KI"
          },
          {
            "ar": "كندا",
            "en": "Canada",
            "code": "CA"
          },
          {
            "ar": "جزر كوك",
            "en": "Cook Islands",
            "code": "CK"
          },
          {
            "ar": "الولايات المتحدة",
            "en": "United States",
            "code": "US"
          },
          {
            "ar": "ميكرونيزيا",
            "en": "Micronesia",
            "code": "FM"
          },
          {
            "ar": "ساموا",
            "en": "Samoa",
            "code": "WS"
          },
          {
            "ar": "تونغا",
            "en": "Tonga",
            "code": "TO"
          },
          {
            "ar": "فانواتو",
            "en": "Vanuatu",
            "code": "VU"
          },
          {
            "ar": "نيوزيلاند",
            "en": "New Zealand",
            "code": "NZ"
          },
          {
            "ar": "الارجنتين",
            "en": "Argentina",
            "code": "AR"
          },
          {
            "ar": "انتجوا وباربودا",
            "en": "Antigua and Barbuda",
            "code": "AG"
          },
          {
            "ar": "باربادوس",
            "en": "Barbados",
            "code": "BB"
          },
          {
            "ar": "بهاما",
            "en": "Bahamas",
            "code": "BS"
          },
          {
            "ar": "برازيل",
            "en": "Brazil",
            "code": "BR"
          },
          {
            "ar": "بوليفيا",
            "en": "Bolivia",
            "code": "BO"
          },
          {
            "ar": "اكوادور",
            "en": "Ecuador",
            "code": "EC"
          },
          {
            "ar": "غريناده",
            "en": "Grenada",
            "code": "GD"
          },
          {
            "ar": "كولومبيا",
            "en": "Colombia",
            "code": "CO"
          },
          {
            "ar": "كوبا",
            "en": "Cuba",
            "code": "CU"
          },
          {
            "ar": "غويانا",
            "en": "Guyana",
            "code": "GY"
          },
          {
            "ar": "بيرو",
            "en": "Peru",
            "code": "PE"
          },
          {
            "ar": "المكسيك",
            "en": "Mexico",
            "code": "MX"
          },
          {
            "ar": "سانت لوسيا",
            "en": "Saint Lucia",
            "code": "LC"
          },
          {
            "ar": "سورينام",
            "en": "Suriname",
            "code": "SR"
          },
          {
            "ar": "ترينيداد وتوباكو",
            "en": "Trinidad and Tobago",
            "code": "TT"
          },
          {
            "ar": "فنزويلا",
            "en": "Venezuela",
            "code": "VE"
          },
          {
            "ar": "اوراغواى",
            "en": "Uruguay",
            "code": "UY"
          },
          {
            "ar": "جامايكا",
            "en": "Jamaica",
            "code": "JM"
          },
          {
            "ar": "شيلى",
            "en": "Chile",
            "code": "CL"
          }
        ]
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
